import { getIframeUrl } from './utils';
import './YandexPayModal.css';

export default [
  '$scope', 'settings', '$sce', 'cardPaymentService', 'config', 'deviceService', 'telemetryService',
  function ($scope, settings, $sce, cardPaymentService, config, deviceService, telemetryService)
  {
    $scope.isMobile = deviceService.isMobile;
    const isYandexKassaV2Enabled = config.get('isYandexKassaV2.Enabled');

    $scope.isYandexKassaV2Enabled = isYandexKassaV2Enabled;
    $scope.handleAddFormYandexFrameLoad = cardPaymentService.setPaymentProcessed;

    $scope.iframeUrl = getIframeUrl({ settings, $sce, isYandexKassaV2Enabled });

    if (isYandexKassaV2Enabled) {
      const { confirmationToken } = settings;

      window.depositWidgetInit = () => {
        telemetryService.increment('yandex-kassa-init.start');

        delete window.depositWidgetInit;
      };

      window.depositWidgetInitFailure = () => {
        telemetryService.increment('yandex-kassa-init.fail');

        delete window.depositWidgetInitFailure;
      };

      window.depositWidgetSuccess = () => {
        $scope.$close();

        // Отсекаем префикс ct- у confirmationToken
        const paymentId = confirmationToken.substring(3);

        cardPaymentService.setPaymentProcessed(true);
        cardPaymentService.runCheckPaymentState(paymentId);

        delete window.depositWidgetSuccess;
      };
    } else {
      $scope.$on('modal.closing', () => {
        cardPaymentService.runCheckPaymentState(settings.clientOrderId);
      });
    }
  },
];
